module.exports = __webpack_public_path__ + "media/images/flf-appearance_aged-acf4bae48fc70bd8958866164e508bd4.jpg";